<script lang="ts">
    import { tweened } from 'svelte/motion';
    import { elasticOut } from 'svelte/easing';
    export let indeterminate: boolean = false;
    export let total_steps: number = 100;
    export let target_steps: number = 50;
    let current_steps = tweened(target_steps, {
		duration: 150,
		easing: elasticOut
	})

    $: {
        current_steps.set(target_steps);
    }
</script>

<div class="progress approu-primary lighten-1">
    <div
        class="{indeterminate ? "indeterminate" : "determinate"} approu-primary darken-1"
        style="width: {Math.round(($current_steps / total_steps) * 100)}%"
    />
</div>
